import { Injectable } from '@angular/core';
import { CarsWidget } from '@com-delta-idp/mnx-sitewide-header-ui';
import { HeaderFooterMachCore } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { AirportDropDown } from '@com-delta-idp/mnx-sitewide-shared-core-ui';
import { SEARCH } from '../../constants/booking-cars/booking-cars.constants';
import { CarsLocationItem } from '../../models/interface/booking-cars/booking-cars.interfaces';
import { getPropertyValue } from './booking-cars-adapter.utils';

@Injectable({
  providedIn: 'root'
})
export class BookingCarsAdapterSuperService {
  errorBannerMessage = '';
  locationsCache: CarsLocationItem[] = [];
  locationLabel = '';
  bookingWidgetAem!: HeaderFooterMachCore;

  setLocationsCache(locations: CarsLocationItem[]): void {
    this.locationsCache = locations;
  }

  getLocationFromCache(code: string): CarsLocationItem | undefined {
    return this.locationsCache.find((loc) => loc.code === code);
  }

  transformLocationsToDropdownItems(locations: CarsLocationItem[]): Array<{
    id: string;
    code: string;
    label: string;
    selected: boolean;
    value: string;
  }> {
    return locations.map((loc, index) => ({
      id: String(index + 1),
      code: loc.code,
      label: loc.name,
      selected: false,
      value: loc.code
    }));
  }

  createLocationModalContent(locations: CarsLocationItem[]): AirportDropDown {
    const label =
      this.bookingWidgetAem?.header?.book?.cars?.searchOptions
        ?.placeHolderLabel ?? SEARCH;

    return {
      airportList: {
        id: 'cars-location-search',
        title: this.locationLabel,
        placeholder: 'Search location...',
        menuVariant: 'transparent',
        hasExternalFiltering: true,
        shouldAutoCapitalize: true,
        hasAutocomplete: true,
        items: this.transformLocationsToDropdownItems(locations),
        errorConfig: {
          validateOnInput: false
        }
      },
      mobileCloseHeaderText: 'Select Location',
      floatingLabelText: this.locationLabel,
      tabOptions: {
        id: 'tabs-width-fixed-small',
        tabVariant: 'standard',
        tabSize: 'small',
        tabWidth: 'fixed',
        tabItems: [
          {
            id: 'search',
            label: label,
            value: label,
            selected: true
          }
        ]
      }
    };
  }

  getLabels(aem: HeaderFooterMachCore): CarsWidget['labels'] {
    const labels = aem?.header?.book?.cars?.labels;
    return {
      pickUpLabel: getPropertyValue(labels, 'pickUpLabel'),
      pickUpTimeLabel: getPropertyValue(labels, 'pickUpTimeLabel'),
      dropOffLabel: getPropertyValue(labels, 'dropOffLabel'),
      dropOffTimeLabel: getPropertyValue(labels, 'dropOffTimeLabel'),
      buttonLabel: getPropertyValue(labels, 'buttonLabel'),
      viewSearchOptionsLabel: getPropertyValue(labels, 'viewSearchOptionsLabel')
    };
  }
}
